import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon'; 
import { CardSelfComponent } from './card-self.component';

const COMPONENTS = [CardSelfComponent];

@NgModule({
  imports: [CommonModule, NzAvatarModule, NzToolTipModule,NzIconModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class CardSelfModule {}
